import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import { Collapse, notification, Popover } from "antd";
import styled from "styled-components";
import { CheckCircle } from "@mui/icons-material";
import { FaCaretDown } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useParams } from "react-router-dom";
import { isNaN } from "lodash";

import Button from "../button";
import FileSaveIcon from "../../../assets/icons/save-file.svg";
import FileSaveIconDisabled from "../../../assets/icons/save-file-disabled.svg";

import { CreatePallets, DownloadPickList, GenerateDeliveryWindowOptions, GenerateTransportationOptions, GetWarehouseShipments, SetPackingInformation } from "../../../slices/post-shipment";

import { generateExcel, generatePDF } from "../../../utils/download-file";

const { Panel } = Collapse;

const Container = styled.div`
  width: 100%;
  .ant-collapse.ant-collapse-icon-position-right {
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
}
  .ant-collapse > .ant-collapse-item{
    border:none;
  }
  .ant-collapse.ant-collapse-icon-position-right {
    border: none;
}
.ant-collapse{
  background-color: transparent;
}
.ant-collapse-content-box{
  padding: 0;
  padding-top: 12px;
}
.button{
  margin-top: 16px;
  
}
.buttons-wrapper{
  display: flex;
  align-items: center;
  grid-gap: 16px;
  justify-content: flex-end;
  padding-right: 24px;
}
`;

const TabHeader = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`;

const StyledPanel = styled(Panel)`

    &.completed-panel .ant-collapse-header {
    background: #FFFFFF !important;
    color: #fff;
    border: 1px solid #009C34;
    padding: 4px 12px;
    span{
      color:#009C34;
    }
}
    &.active-panel .ant-collapse-header {
    background: #1565D8;
    color: #fff;
}
    .ant-collapse-header {
    background: #F3F3F3;
    color: #808183;
    border-radius: 4px;
    padding: 4px 12px;
    span{
      font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    }
}
`;

const DropdownStyledWrapper = styled.div`
.menu-wrapper-id {
  p {
    margin: 0px;
    padding: 4px 12px;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    vertical-align: middle;
    color: #4E5969;
    &:hover{
      background: #F5F5F5;
      cursor: pointer;
    }
}
}
`;

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const AccordionStepper = ({
  steps,
  setActiveKey,
  setIsSubmitPackingInfo,
  isSubmitPackingInfo,
  setIsShowData,
  activeKey,
  activeShipmentIndex,
  setActiveShipmentIndex,
  setShipmentsData,
  shipmentsData,
  setContactDetails,
  contactDetails,
  deletedPallets,
  setDeletedPallets
}) => {
  const [completedSteps, setCompletedSteps] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [downloadPickListLoading, setDownloadPickListLoading] = useState(false);
  const [downloadType, setDownloadType] = useState('');

  const dispatch = useDispatch();
  const { workOrderId } = useParams();

  const {
    shipmentDetails,
    fetchingWarehouseShipments,
    settingPackInformation,
    creatingPallets,
    generatingTransportationOptions,
    generatingDeliveryWindowOptions,
  } = useSelector((state) => state.postShipment || {});

  const { inboundStatus } = shipmentDetails || {};

  const downloadPickList = (type) => {
    setDownloadType(type);
    const pathSegments = window.location.pathname.split("/");
    const workOrderId = pathSegments.pop();
    setShowPopover(false);

    setDownloadPickListLoading(true);
    dispatch(DownloadPickList(workOrderId)).then(({ payload }) => {
      if (payload.success) {
        const { pickList = [], orderName } = payload;
        (type === 'excel' || type === 'both') && generateExcel({ pickList, orderName });
        (type === 'pdf' || type === 'both') && generatePDF({ pickList, orderName });
        setDownloadPickListLoading(false);
      }
    });
  }
  const handleConfirm = (key) => {
    downloadPickList('both');
    if (!completedSteps.includes(key)) {
      setCompletedSteps([...completedSteps, key]);

      const currentIndex = steps.findIndex((step) => step.key === key);
      if (currentIndex !== -1 && currentIndex < steps.length - 1) {
        setActiveKey(steps[currentIndex + 1].key);
      }
    }
  };

  const getSubmitBtnDisabledStatus = () => {
    return (
      creatingPallets ||
      generatingTransportationOptions ||
      generatingDeliveryWindowOptions ||
      fetchingWarehouseShipments || shipmentsData.some(({
        pallets,
        freightInfo
      }) => {
        const { name, phone, email, shipDate } = contactDetails || {};

        if (!pallets?.length) return true;

        return (
          !name ||
          !phone ||
          !email ||
          isNaN(Number(phone)) ||
          (Number(phone) <= 0) ||
          !EMAIL_REGEX.test(email) ||
          !shipDate ||
          !freightInfo?.class ||
          freightInfo?.class === '0.00' ||
          pallets.some(({
            height,
            weight,
            noOfPallets,
            stackable,
          }) =>
            !height || !weight || !noOfPallets ||
            isNaN(Number(height)) || isNaN(Number(weight)) || isNaN(Number(noOfPallets)) ||
            (Number(height) <= 0) || (Number(weight) <= 0) || (Number(noOfPallets) <= 0) ||
            !stackable
          ));
      }));
  };

  const formatDateForAmazon = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().replace(".000", "");
  };

  const handleSubmitPackingInformation = () => {
    if (isSubmitPackingInfo) {
      const mappedPallets = shipmentsData.flatMap(shipment => {
        const { pallets, amazon_shipment_id: amazonShipmentId } = shipment;

        return pallets
          .map(({
            id,
            noOfPallets,
            height,
            width,
            length,
            weight,
            stackable,
          }) => ({
            id,
            noOfPallets: Number(noOfPallets),
            height,
            width,
            length,
            weight,
            isStacked: stackable === 'Yes',
            amazonShipmentId,
          }));
      });

      const shipmentsFreightInfo = shipmentsData.map(shipment => {
        const { freightInfo, amazon_shipment_id: amazonShipmentId } = shipment;

        return {
          freightInfo,
          amazonShipmentId
        }
      });

      const { amazonInboundPlanId: inboundPlanId, shipments } = shipmentDetails || {};

      dispatch(CreatePallets({
        pallets: mappedPallets,
        deletedPallets,
        contactDetails,
        shipmentsFreightInfo,
        inboundPlanId
      }))
        .then(({ payload }) => {
          if (payload?.success) {
            setDeletedPallets([]);
            const shipmentTransportationConfigurations = shipmentsData.map(({
              amazon_shipment_id,
              freightInfo,
              pallets,
            }) => {
              const { name, phone: phoneNumber, email, shipDate } = contactDetails || {};

              return {
                contactInformation: {
                  email,
                  name,
                  phoneNumber,
                },
                freightInformation: {
                  declaredValue: {
                    amount: Number(freightInfo?.value),
                    code: 'USD'
                  },
                  freightClass: `FC_${Number(freightInfo?.class || 0).toString().replace('.', '_')}`
                },
                pallets: pallets?.map(({
                  height,
                  length,
                  width,
                  weight,
                  noOfPallets,
                  stackable,
                }) => {
                  return {
                    dimensions: {
                      height: Number(height),
                      length: Number(length),
                      unitOfMeasurement: 'IN',
                      width: Number(width)
                    },
                    quantity: noOfPallets,
                    stackability: (stackable === 'Yes') ? 'STACKABLE' : 'NON_STACKABLE',
                    weight: {
                      unit: 'LB',
                      value: Number(weight)
                    }
                  }
                }) || [],
                readyToShipWindow: {
                  start: formatDateForAmazon(shipDate)
                },
                shipmentId: amazon_shipment_id
              }
            });

            dispatch(GenerateTransportationOptions({
              inboundPlanId,
              placementOptionId: shipments[0]?.amazon_placement_option_id,
              shipmentTransportationConfigurations
            }))
              .then(async ({ payload }) => {
                if (payload?.success) {
                  const requests = shipments.map(({ amazon_shipment_id: shipmentId }) =>
                    dispatch(GenerateDeliveryWindowOptions({ inboundPlanId, shipmentId }))
                  );

                  await Promise.all(requests);

                  notification['success']({
                    message: 'Delivery Window Options Generated Successfully',
                    top: 65,
                  });

                  dispatch(GetWarehouseShipments({
                    workOrderId,
                  }));
                  setActiveKey('3');
                }
              })
          }
        });
      return;
    }

    dispatch(SetPackingInformation(workOrderId))
      .then(({ payload }) => {
        if (payload?.success) {
          dispatch(GetWarehouseShipments({
            workOrderId,
          }));
        }
      });
  };
  // useEffect(() => {
  //   const handleClickOutside = () => {
  //     setShowPopover(false);
  //   };
  //   window.addEventListener("click", handleClickOutside);
  //   return () => {
  //     window.removeEventListener("click", handleClickOutside);
  //   };
  // }, []);

  return (
    <Container>
      <Collapse defaultActiveKey={['1']}
        expandIcon={({ isActive }) => (
          <FaCaretDown
            style={{ fontSize: "16px", top: '10px', transition: "transform 0.2s", transform: `rotate(${isActive ? 180 : 0}deg)` }}
            rotate={isActive ? 90 : 0}
          />
        )} expandIconPosition="right" activeKey={activeKey} onChange={(key) => {
          if (
            (key == '2' && ['Confirmed', 'BOXED'].includes(inboundStatus)) ||
            (key == '3' && inboundStatus === 'PACKED') ||
            (key == '4' && inboundStatus === 'TRANSPORTATION_CONFIRMED') ||
            (key == '5')
          ) setActiveKey(key);
        }} accordion>
        {steps.map((step, index) => {
          const isActive = Array.isArray(activeKey) ? activeKey.includes(step.key) : activeKey === step.key;
          const isCompleted = completedSteps.includes(step.key);
          const isDisabled = index > 0 && !completedSteps.includes(steps[index - 1].key);

          return (
            <StyledPanel
              key={step.key}
              className={`${isActive ? "active-panel" : ""} ${isCompleted ? "completed-panel" : ""}`}
              header={
                <TabHeader>
                  <span>
                    {completedSteps.includes(step.key) ? (
                      <CheckCircle style={{ color: "green", marginRight: 8 }} />
                    ) : (
                      null
                    )}
                    {step.title}
                  </span>
                </TabHeader>
              }
            >
              {step.content}
              <div className="buttons-wrapper">
                {(step.key === '2' && !isSubmitPackingInfo) &&
                  <Popover overlayClassName="file-down-loa-ded-wrapper" visible={showPopover} content={
                    <DropdownStyledWrapper>
                      <div className="menu-wrapper-id">
                        <p onClick={() => downloadPickList('excel')}>By Excel File</p>
                        <p onClick={() => downloadPickList('pdf')}>By PDF File</p>
                      </div>
                    </DropdownStyledWrapper>
                  } placement="bottom"><Button
                      endIcon={<IoIosArrowDown onClick={(e) => {
                        setShowPopover(!showPopover);
                        e.stopPropagation();
                      }} />}
                      startIcon={<img src={FileSaveIcon} alt="FileSaveIcon" />}
                      className="outlined button"
                      text={downloadPickListLoading ? `Downloading ${downloadType === 'pdf' ? 'PDF' : downloadType === 'excel' ? 'Excel' : 'Files'}` : "Download pick list"}
                      disabled={downloadPickListLoading}
                      onClick={() => setShowPopover(!showPopover)}
                    /></Popover>}
                {step.key === '1' && <Button className="button" text="Confirm Placement Option" disabled={isCompleted || isDisabled} onClick={() => handleConfirm(step.key)} />}
                {step.key === '2' &&
                  <Button className="button"
                    text={isSubmitPackingInfo === true ? "Submit" : "Submit Packing Information"}
                    onClick={handleSubmitPackingInformation}
                    disabled={
                      isSubmitPackingInfo ? getSubmitBtnDisabledStatus() :
                        (settingPackInformation || fetchingWarehouseShipments)
                    }
                  />}
              </div>
            </StyledPanel>
          )
        })}
      </Collapse>
    </Container>
  );
};

export default AccordionStepper;
